// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


// ToDo: Find a better Spot for this utility type
type RequireProperties<T, K extends keyof T> = T & { [P in K]-?: T[P] }
type UpdatePledgeResponse = SuccessResponse | FailedResponse

export class UpdatePledgeRequest extends Request {
    private constructor(groupId: string, pledgeId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}/pledge/${pledgeId}`, init) }
    static async init(groupId: string, pledge: RequireProperties<Partial<Pledge>, 'id'>, init?: RequestInit) {
        return new UpdatePledgeRequest(groupId, pledge.id, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(pledge)
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<UpdatePledgeResponse>(await response.json())
        console.info("Update Pledge Results:", data)
    
        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}